import type { RiderFormValues } from '../../types';

export type RiderServicesPayload = {
  codeWord: string;
  frontSeatAuthorized: boolean;
  boosterSeat: boolean;
  services: string[];
  supportSettings: { supportType: string; details: string }[];
  riderNotes: string;
};

export const toRiderServicesPayload = (values: RiderFormValues): RiderServicesPayload => {
  const selectedSettings = values.supportSettings
    .filter((entry) => entry.selected)
    .map((entry) => ({ supportType: entry.supportType, details: entry.details }));

  return {
    codeWord: values.codeWord,
    frontSeatAuthorized: values.frontSeatAuthorized,
    boosterSeat: values.boosterSeat,
    services: values.services,
    supportSettings: selectedSettings,
    riderNotes: values.riderNotes,
  };
};
